import { ISelectItem } from "@/types";
import {
  IAlertcondition,
  IAlertconditionCreateRequest,
  IAlertconditionListRequest,
  IAlertconditionRequest,
  IAlertconditionUpdateRequest,
} from "@/types/alertcondition";
import { ListRequest } from "./listRequest";

export class Alertcondition implements IAlertcondition {
  public id = 0;
  public company_id = 0;
  public member_id = 0;
  public tag_id = 0;
  public span = 0;
  public name = "";

  public constructor(props?: IAlertcondition) {
    if (!props) {
      return;
    }

    Object.assign(this, props);
  }

  public static toSelectItem(alertcondition: IAlertcondition): ISelectItem {
    return {
      text: alertcondition.name,
      value: alertcondition.id,
    };
  }
}

export class AlertconditionRequest implements IAlertconditionRequest {
  public name = "";
  public span = 0;
  public company_id = 0;
  public member_id = 0;
  public tag_id = 0;

  [key: string]: unknown;
}

export class AlertconditionCreateRequest
  extends AlertconditionRequest
  implements IAlertconditionCreateRequest {}

export class AlertconditionUpdateRequest
  extends AlertconditionRequest
  implements IAlertconditionUpdateRequest
{
  public id = 0;

  public constructor(props?: IAlertcondition) {
    super();

    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}

export class AlertconditionListRequest
  extends ListRequest
  implements IAlertconditionListRequest {}
